"use client";
import { usePrice } from "@/hooks";
import { useGetHostingPackagesQuery } from "@/store";
import { setToLocale } from "@/utils";
import { useTranslations } from "next-intl";
import Image from "next/image";
import { useRouter } from "next/navigation";
import { Fragment } from "react";
import { useSelector } from "react-redux";

export function WebHostingPlans({ isPopular = true }) {
  const { data } = useGetHostingPackagesQuery();
 const formatAmount = usePrice();
  const {
    formType: { webHosting },
  } = useSelector((state) => state.common);
  const navigate = useRouter();
  const t = useTranslations();
  const getStarted = ({
    package_options,
    id,
    cost,
    cost_yearly,
    packageName,
  }) => {
    const options = {};
    options["name"] = packageName;
    package_options?.map(({ value, name }) => {
      switch (name) {
        case t("storageOption"):
          return (options["storage"] = value);
        case t("bandwidth"):
          return (options["bandwidth"] = value);
        case t("sslAside"):
          return (options["ssl"] = value);
        case t("emailAside"):
          return (options["email"] = value);
        case t("website"):
          return (options["website"] = value);
        case t("includedDomain"):
          return (options["domain"] = value);
      }
    });
    setToLocale({
      key: "whPackage",
      value: { options, id, cost, cost_yearly },
    });
    navigate.push("/web-hosting/purchase");
  };
  return (
    <article className="grid sm:grid-cols-2 md:grid-cols-4 text-black w-full md:mx-auto mx-2 border border-[1px]-slate-200 rounded-lg">
      {data?.body?.hosting_packages?.map((values, idxPackages) => {
        const {
          id: packageId,
          name,
          package_options,
          cost,
          cost_yearly,
        } = values;
        return (
          <div key={packageId} className="flex flex-col items-center">
            <h2
              className={`relative border-r-[1px] border-slate-200  h-[88px] flex flex-col items-center justify-center w-full text-slate-700 text-xl font-medium ${
                idxPackages === data?.body?.hosting_packages?.length - 1
                  ? "border-r-0"
                  : ""
              }`}
            >
              {name}
              {!!idxPackages > 0 && (
                <span className="text-base font-normal text-slate-500">
                  {webHosting === "monthly" ? (
                    <>
                      {formatAmount(cost)}/{t("month")}
                    </>
                  ) : (
                    <>
                      {formatAmount(cost_yearly)}/{t("year")}
                    </>
                  )}
                </span>
              )}
              {idxPackages == 2 && !!isPopular && (
                <i className="absolute top-0 right-0">
                  <Image
                    src="/icons/popular_icon.svg"
                    width={88}
                    height={88}
                    alt="popular_icon"
                  />{" "}
                </i>
              )}
            </h2>
            {idxPackages === 0
              ? data?.body?.package_options?.map(({ id, name }, idx) => (
                  <div
                    key={id}
                    className={`border-r-[1px] border-slate-200 text-base text-slate-700 h-[58px] flex items-center justify-center w-full text-center ${
                      idx % 2 === 0 ? "bg-slate-50" : ""
                    }`}
                  >
                    {name}
                  </div>
                ))
              : package_options.map(({ id, value }, idx) => {
                  return (
                    <Fragment key={id}>
                      <li
                        className={`border-r-[1px] border-slate-200 text-base text-slate-700 h-[58px] flex items-center justify-center w-full text-center ${
                          idx % 2 === 0 ? "bg-slate-50" : ""
                        }
                           ${
                             idxPackages ===
                             data?.body?.hosting_packages?.length - 1
                               ? "border-r-0"
                               : ""
                           }
                      `}
                      >
                        {typeof value === "boolean" && value ? (
                          <Image
                            src="/icons/green_circle_okay.svg"
                            width={24}
                            height={24}
                            alt="icon"
                            className={("w-[20px]", "h-[20px]")}
                          />
                        ) : typeof value === "boolean" && !value ? (
                          <Image
                            src="/icons/red_circle_wrong.svg"
                            width={24}
                            height={24}
                            alt="icon"
                            className={("w-[20px]", "h-[20px]")}
                          />
                        ) : (
                          t(value)
                        )}
                      </li>
                    </Fragment>
                  );
                })}

            {!!idxPackages > 0 && (
              <li
                className={`w-full border-r-[1px] border-slate-200 flex items-center ${
                  idxPackages === 1 ? "border-l-[1px]" : ""
                } 
                   ${
                     idxPackages === data?.body?.hosting_packages?.length - 1
                       ? "border-r-0"
                       : ""
                   }
              `}
              >
                <button
                  onClick={() =>
                    getStarted({
                      package_options,
                      id: packageId,
                      cost,
                      cost_yearly,
                      packageName: name,
                    })
                  }
                  className="mb-4 px-8 text-base mx-auto font-medium leading-[24px] w-[90%] h-[50px] bg-mainLightPurple hover:bg-mainLightPurpleHover active:bg-mainLightPurpleActive rounded-lg text-white"
                >
                  {t("getStarted")}
                </button>
              </li>
            )}
          </div>
        );
      })}
    </article>
  );
}
